const clientPageStyle = (theme) => ({
  formControlLabel: { color: "unset" },
  cursorLink: {
    "&:hover": {
      cursor: "pointer",
    },
  },
  filterStyle: {
    backgroundColor: "#FFFFFF",
    padding: "0 10px 0 10px",
  },
  card: {
    margin: "10px 0 10px 0",
  },
  partnerSection: {
    ...theme.arrowItem,
    padding: "0 10px",
    height: "50px",
  },
  arrowTipItem: {
    ...theme.arrowTipItem,
    "&:after": {
      ...theme.arrowTipItem["&:after"],
      borderTop: "25px solid transparent",
      borderBottom: "25px solid transparent",
    },
  },
  partnerName: {
    ...theme.ellipsisLabel,
    fontFamily: "SparBd",
    fontSize: "14px",
  },
  partnerNameWithRoles: {
    textAlign: "start",
    marginBottom: "-5px",
    fontWeight: 600,
    fontSize: "0.8rem",
  },
  partnerRole: {
    paddingBottom: "3px",
    marginRight: "5px",
    fontWeight: 600,
    fontSize: "0.8rem",
    fontFamily: "SparBd",
  },
  partnerData: (props) => {
    return {
      backgroundColor: props.selected ? "#eaf4e9" : "white",
      height: "50px",
      padding: "0 25px",
    };
  },
  reducedFont: { fontSize: "11px" },
  minFont: { fontSize: "9px" },
  checkBox: {
    padding: 0,
    color: "#008000",
  },
  flexDisplay: {
    display: "flex",
    width: "100%",
    alignItems: "center",
    paddingTop: "5px",
  },
  width80: {
    width: "80%",
  },
  paddingLeft15: {
    paddingLeft: "15px",
  },
  autocomplete: {
    color: "white",
    paddingBottom: "0px !important",
    fontSize: "0.8rem",
  },
  underline: {
    "&:before": {
      borderBottom: "1px solid white",
    },
    "&:after": {
      borderBottom: "2px solid white",
    },
  },
  colorWhite: {
    color: "white !important",
  },
  boldTitle: {
    padding: "5px 0",
    fontWeight: "bold",
  },
  btn150: {
    minWidth: 150,
    maxWidth: 150,
    whiteSpace: "nowrap",
  },
  rightAlign: {
    marginRight: 0,
    marginLeft: "auto",
  },
  marginRight: {
    marginRight: "10px",
  },
  cardAddress: {
    margin: "0 0 10px 0",
  },
});

export default clientPageStyle;
